// @mui
import { useTheme, styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import Badge, { badgeClasses } from '@mui/material/Badge';
// hooks
import { useOffSetTop } from 'src/hooks/use-off-set-top';
import { useResponsive } from 'src/hooks/use-responsive';
// theme
import { bgBlur } from 'src/theme/css';
// routes
import { paths } from 'src/routes/paths';
// components
import Logo from 'src/components/logo';
import Label from 'src/components/label';
//

import { usePathname } from 'src/routes/hook';
import LanguagePopover from 'src/components/language-popover';
import { HEADER } from '../config-layout';
import { navConfig } from './config-navigation';
// import NavMobile from './nav/mobile';
import NavDesktop from './nav/desktop';
//
// import { SettingsButton, HeaderShadow, LoginButton } from '../_common';
import NavMobile from './nav/mobile/nav-mobile';

// utils
import cssStyles from '../../utils/cssStyles';
// config

// ----------------------------------------------------------------------

export default function Header() {
  const theme = useTheme();

  const pathName = usePathname();

  const mdUp = useResponsive('up', 'md');

  const offsetTop = useOffSetTop(HEADER.H_DESKTOP);


  const ToolbarStyle = styled(Toolbar, {
    shouldForwardProp: (prop) => prop !== 'transparent' && prop !== 'scrolling',
  })<any>(({ transparent, scrolling }) => ({
    height: HEADER.H_MOBILE,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.default,
    transition: theme.transitions.create(['height', 'background-color'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.short,
    }),
    [theme.breakpoints.up('md')]: {
      height: HEADER.H_DESKTOP,
    },
    ...(transparent && {
      color: theme.palette.common.white,
      backgroundColor: 'transparent',
    }),
    ...(scrolling && {
      ...cssStyles(theme).bgBlur(),
      [theme.breakpoints.up('md')]: {
        height: HEADER.H_DESKTOP - 20,
      },
    }),
  }));

  const isScrolling = useOffSetTop(HEADER.H_DESKTOP);

  return (
    <AppBar
      color="transparent"
      sx={{
        boxShadow: 'none',
        bgcolor: 'transparent'
      }}
    >
      <ToolbarStyle
        disableGutters
        transparent
        scrolling={isScrolling}
        // sx={{
        //   height: {
        //     xs: HEADER.H_MOBILE,
        //     md: HEADER.H_DESKTOP,
        //   },

        //   transition: theme.transitions.create(['height'], {
        //     easing: theme.transitions.easing.easeInOut,
        //     duration: theme.transitions.duration.shorter,
        //   }),
        //   ...(offsetTop && {
        //     ...bgBlur({
        //       color: theme.palette.background.default,
        //     }),
        //     height: {
        //       md: HEADER.H_DESKTOP_OFFSET,
        //     },
        //   }),
        // }}
      >
        <Container sx={{ height: 1, display: 'flex', alignItems: 'center' }}>
          <Badge
            sx={{
              [`& .${badgeClasses.badge}`]: {
                top: 8,
                right: -16,
              },
            }}
          >
            <Logo />
          </Badge>

          <Box sx={{ flexGrow: 1 }} />

          {mdUp && <NavDesktop offsetTop={offsetTop} data={navConfig} />}

          <LanguagePopover />
          <Stack alignItems="center" direction={{ xs: 'row', md: 'row-reverse' }}>
            {/* {pathName === '/'&& mdUp && (
              <>
                {' '}
                <Button variant="outlined" target="_blank" rel="noopener" href={paths.register}>
                  Register Now
                </Button>
                {mdUp && <LoginButton />}
              </>
            )} */}

            {!mdUp && <NavMobile offsetTop={offsetTop} data={navConfig} />}
          </Stack>
        </Container>
      </ToolbarStyle>
      {/* 
      {offsetTop && <HeaderShadow />} */}
    </AppBar>
  );
}
